import { LinearProgress } from '@material-ui/core';
import React, { DetailedHTMLProps, HTMLAttributes, ReactElement } from 'react';
import { VoxelAlertProps } from '../Alert/VoxelAlert';
import VoxelAppBarAlert from './VoxelAppBarAlert';

export interface VoxelAppBarProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  dense?: boolean;
  isScrolling?: boolean;
  className?: string;
  shadow?: boolean;
  border?: boolean;
  bgClass?: string;
  loading?: boolean;
  voxelAlert?: ReactElement<VoxelAlertProps>[];
}

export const VoxelAppBar: React.FC<VoxelAppBarProps> = ({
  children,
  isScrolling,
  dense,
  className = '',
  shadow,
  border,
  bgClass = '',
  loading,
  voxelAlert,
  ...otherProps
}) => {
  return (
    <div
      className={`
        w-full fixed top-0 left-0 right-0 z-[1400] 
        ${border && 'border-b border-[#eee]'}  
        ${bgClass}  
        ${shadow ? 'shadow-appBar' : 'shadow-none'}
          transition duration-200
        `}
    >
      <div
        className={`
          w-full px-6 flex flex-row flex-nowrap items-center justify-between
          ${dense ? 'h-12' : 'h-14'}  
          ${className}
          `}
      >
        {children}
      </div>
      {loading && (
        <LinearProgress
          color="primary"
          classes={{
            colorPrimary: '!bg-voxel-blue-200',
            bar: '!bg-voxel-blue-100',
            root: '!h-[3px] opacity-60 -mt-[2px]',
          }}
        />
      )}
      {!!voxelAlert?.length &&
        voxelAlert.map(
          (a) =>
            a !== undefined && (
              <VoxelAppBarAlert key={a?.props?.id} voxelAlert={a} isScrolling={isScrolling} />
            )
        )}
    </div>
  );
};

export default VoxelAppBar;
